var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.statusSpecificConfig.className,attrs:{"title":_vm.statusSpecificConfig.title}},[_c('i',{class:_vm.statusSpecificConfig.icon}),_vm._v(" "+_vm._s(_vm._f("humanise")(_vm.credit.outward_facing_status))+"\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27918e03","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Credits/OutwardFacingStatusLabel.vue
// module id = 768
// module chunks = 0 1